<template>
    <div v-if="entry.finalPercentage !== null || entry.price" class="ItemPrice" :class="{'is-individual': entry.price === -1}">
        <template v-if="entry.finalPercentage !== null">
            <template v-if="entry.finalPercentage < 0">
                Sleva z celkové ceny {{entry.finalPercentage}}%
            </template>
            <template v-else>
                Příplatek k celkové ceně {{entry.finalPercentage}}%
            </template>
        </template>
        <template v-else>
            Cena<span v-if="entry.isPriceFrom"> od</span>: {{ formatPrice(entry.price) }}
            <small v-if="entry.isPriceFrom" class="is-individual">V případě zájmu Vám bude zpracována konkrétní cenová nabídka.</small>
            <small v-else>včetně DPH</small>
        </template>
    </div>
</template>

<script>
import {formatPrice} from "../utils/utils";

export default {
    name: 'ItemPrice',
    props: {
        entry: Object
    },
    setup () {
        return {
            formatPrice
        }
    }
}
</script>

<style lang="scss" scoped>
.ItemPrice {
    background: var(--colorBrandLighten);
    padding: 1em;
    font-weight: 700;
    text-align: center;
    margin-top: 1.3em;
    line-height: 1.5;

    &.is-individual {
        background: rgb(248 232 240);
    }

    small {
        display: block;
        font-weight: 400;
        font-size: .7em;

        &.is-individual {
            font-size: .8em;
        }
    }
}
</style>
